/**
 * For filters and pagination
 */

/* 
   Function: getUrlVars
   
   Description: 
   This function reads the GET URL variables and returns them as an associative array. It extracts the variables and their values from the query string of the current page's URL.
*/

function getUrlVars() {
  var vars = [],
    hash;
  var hashes = window.location.href
    .slice(window.location.href.indexOf("?") + 1)
    .split("&");
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split("=");
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
}

/* 
   Function: getAbsolutePath
   
   Description: 
   This function retrieves the absolute path of the current page's URL, excluding the query string, hash, and file name.
*/

function getAbsolutePath() {
  var loc = window.location;
  var pathName = loc.pathname.substring(0, loc.pathname.lastIndexOf("/") + 1);
  return loc.href.substring(
    0,
    loc.href.length -
      ((loc.pathname + loc.search + loc.hash).length - pathName.length)
  );
}

/* 
   Function: getObjKey
   
   Description: 
   This function returns the key of an object based on the provided value.
*/

function getObjKey(obj, value) {
  return Object.keys(obj).find((key) => obj[key] === value);
}

// Event listener for pagination tabs

$(document).on("click", ".pagination_tab", function (e) {
  let click_count = $(e.target).text();
  let active_page_count = $(".active_page").text();
  if (active_page_count == click_count) {
  } else {
    if (
      click_count != undefined &&
      click_count != "undefined" &&
      click_count != ""
    ) {
      pageNumber = parseInt(click_count);
    } else {
      console.log("Some error occurs!");
    }
    ajax_data();
  }
});

// Event listener for previous button
$(document).on("click", ".previous", function (e) {
  if ($(e.target).hasClass("disabled")) {
  } else {
    let active_page_count = $(".active_page").text();
    if (
      active_page_count != undefined &&
      active_page_count != "undefined" &&
      active_page_count != ""
    ) {
      pageNumber = active_page_count - 1;
    } else {
      pageNumber = pageNumber - 1;
    }
    ajax_data();
  }
});
// Event listener for next button
$(document).on("click", ".next", function (e) {
  if ($(e.target).hasClass("disabled")) {
    console.log("next is disabled!");
  } else {
    let active_page_count = $(".active_page").text();
    if (
      active_page_count != undefined &&
      active_page_count != "undefined" &&
      active_page_count != ""
    ) {
      pageNumber = parseInt(active_page_count) + 1;
    } else {
      pageNumber = parseInt(pageNumber) + 1;
    }
    ajax_data();
  }
});

/* 
   Function: pageUrl
   
   Description: 
   This function constructs and returns the URL for pagination based on the provided parameters such as treatment, hospital, location, pageNumber, and search query.
*/

function pageUrl(
  treatment = undefined,
  hospital = undefined,
  location = undefined,
  pageNumber = undefined,
  search = undefined
) {
  let query_string = "";
  if (
    treatment &&
    treatment != "undefined" &&
    treatment != undefined &&
    treatment != ""
  ) {
    let treatment_text = $(".treatment option:selected").text();
    query_string += "&treatments=" + treatment_text;
  }
  console.log($(".hospitals").val());
  if (
    hospital &&
    hospital != "undefined" &&
    hospital != undefined &&
    hospital != ""
  ) {
    let hospital_text = $(".hospitals").val();
    query_string += "&hospitals=" + hospital_text;
  }
  if (
    location &&
    location != "undefined" &&
    location != undefined &&
    location != ""
  ) {
    let location_text = $(".location option:selected").text();
    query_string += "&location=" + location_text;
  }
  if (search && search != "undefined" && search != undefined && search != "") {
    let search_text = $(".search").val();
    query_string += "&search=" + search_text;
  }
  if (
    pageNumber &&
    pageNumber != "undefined" &&
    pageNumber != undefined &&
    pageNumber != ""
  ) {
    if (pageNumber != 1) {
      query_string += "&pages=" + pageNumber;
    }
  }
  let absolute_path = getAbsolutePath();
  let page_url = absolute_path;

  if (
    query_string != "" &&
    query_string != "undefined" &&
    query_string != undefined
  ) {
    page_url = absolute_path + "?" + query_string;
  }
  return page_url;
}
function scrollPage(value = undefined) {
  if (value && value != "undefined" && value != undefined && value != "") {
    value = 50;
  }
  $("html, body").animate({ scrollTop: value }, 0);
}
$(document).ready(function () {
  $(".search-form").find('input[value="1398"]').remove();
});
